<div class="table-wrapper">
  <table class="data-table">
    <thead>
      <tr>
        <th>File</th>
        <th>Current Status</th>
        <th>Expected Location</th>
        <th>Exists</th>
        <th>Size</th>
        <th>Hash</th>
        <th>Result</th>
      </tr>
    </thead>
    <tbody>
      @for (file of files; track trackByFileId($index, file)) {
        <tr [class]="getRowClass(file.result)">
          <td>
            <div class="file-name">{{ file.fileName }}</div>
            <div class="file-meta">
              @if (file.fileNumber) {
                <span>#{{ file.fileNumber }} | </span>
              }
              <span>Total Checks: {{ file.totalChecks }}</span>
              <span> | Total DDA(s): {{ file.totalDdas }}</span>
              @if (file.totalAmount) {
                <span> | ${{ file.totalAmount | number: '1.2-2' }}</span>
              }
            </div>
          </td>
          <td>
            <span class="status-badge">{{ file.currentStatus ?? '—' }}</span>
          </td>
          <td class="path-cell">{{ file.expectedLocation ?? '—' }}</td>
          <td>
            <span [class]="getExistsClass(getPrimaryExists(file))">{{
              getExistsLabel(getPrimaryExists(file))
            }}</span>
          </td>
          <td class="size-hash">
            {{
              getPrimarySize(file) !== null
                ? (getPrimarySize(file)! | number) + ' B'
                : '—'
            }}
          </td>
          <td class="mono">{{ getPrimaryHash(file) ?? '—' }}</td>
          <td>
            <span
              class="result-badge"
              [class]="getResultBadgeClass(file.result)">
              <span class="dot" [class]="getDotClass(file.result)"></span>
              {{ getResultLabel(file.result) }}
            </span>
            @if (file.errorMessage) {
              <div class="error-hint">
                {{ file.errorMessage }}
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
